'use client';

import { useEffect, useState } from 'react';
import { useTranslation, api } from '@weareconceptstudio/core';
import { ProductPopup } from '@weareconceptstudio/ecommerce/v1';
import { trackViewItem } from '@/libs/dataLayer';

/**
 * Wrapper component for ProductPopup that adds view_item tracking
 */
const ProductPopupWithTracking = ({ popupProps, ...props }) => {
	const { selectedLang } = useTranslation();
	const [hasTracked, setHasTracked] = useState(false);

	useEffect(() => {
		// Track view_item when product popup is opened
		if (popupProps?.slug && !hasTracked) {
			const fetchAndTrack = async () => {
				try {
					const { data } = await api.get({ url: `/product/${popupProps.slug}`, lang: selectedLang });

					// Track view_item with product data
					trackViewItem(data, {
						variant: data.selectedVariant,
						option: data.selectedOption,
					});

					setHasTracked(true);
				} catch (error) {
					console.error('Error fetching product for tracking:', error);
				}
			};

			fetchAndTrack();
		}
	}, [popupProps?.slug, selectedLang, hasTracked]);

	// Reset tracking when popup closes (slug changes)
	useEffect(() => {
		setHasTracked(false);
	}, [popupProps?.slug]);

	return (
		<ProductPopup
			popupProps={popupProps}
			{...props}
		/>
	);
};

export default ProductPopupWithTracking;
